import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import {RatingUnit} from '../../model/rating-unit';
import {ScheduleLineInput} from '../../model/schedule-line-input';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-mass-update-errors',
    templateUrl: './mass-update-errors.component.html',
    styleUrls: ['./mass-update-errors.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatPaginator, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton]
})
export class MassUpdateErrorsComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<MassUpdateErrorsComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  ratingUnits: RatingUnit[];
  scheduleLineInputs: ScheduleLineInput[];
  readonly datasource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['modelSize', 'errorMessage'];

  constructor() {
    this.ratingUnits = this.data.ratingUnits;
    this.scheduleLineInputs = this.data.scheduleLineInputs;
  }

  ngOnInit(): void {
    if (this.ratingUnits) {
      this.buildRatingUnitDatasource();
    } else if (this.scheduleLineInputs) {
      this.buildScheduleLineDatasource();
    } else {
      this.dialogRef.close();
    }
  }

  private buildRatingUnitDatasource(): void {
    const errorUnits: any[] = [];
    for (const unit of this.ratingUnits) {
      errorUnits.push({
        modelSize: unit.modelCode + unit.sizeCode,
        errorMessage: unit.response.ErrorMessage
      });
    }
    this.datasource.data = errorUnits;
    this.datasource.paginator = this.paginator;
  }

  private buildScheduleLineDatasource(): void {
    const errorUnits: any[] = [];
    for (const input of this.scheduleLineInputs) {
      errorUnits.push({
        modelSize: input.candidate.ratingRequest.Model + input.candidate.ratingRequest.Size,
        errorMessage: input.candidate.ratingResponse.ErrorMessage
      });
    }
    this.datasource.data = errorUnits;
    this.datasource.paginator = this.paginator;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
